/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-third-party-audience-edit-route-page',
  template: `
    <adn-third-party-audience-item-page
      [model]="model"
      [modelComms]="modelComms"
      [isNew]="isNew">
    </adn-third-party-audience-item-page>
  `
})
export class ThirdPartyAudienceEditRoutePageComponent {
  @Input() model: any;
  @Input() modelComms: any;
  @Input() isNew: boolean;
}
